"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClass = void 0;
var _helpers = require("./helpers");
// Copyright 2017-2023 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @name isClass
 * Tests if the supplied agrument is a Class
 */
const isClass = /*#__PURE__*/(0, _helpers.isOnFunction)('isPrototypeOf', 'hasOwnProperty');
exports.isClass = isClass;